package com.upcominds.expedite.data.documents

class JsDocumentPicker : DocumentPicker {
    override suspend fun pickPdf(): PickedDocument? = null
}
